export const parseInitialValues = entrance => entrance && entrance.attributes.type === 'info' ? {
  entranceInfo: entrance.attributes.content,
} : {};

export const formValues = [
  'entranceInfo',
];
